// Small display helpers shared by the item tile and the item detail view.

export const CATEGORIES = [
  "paintings",
  "furniture",
  "knick-knacks",
  "letters",
  "journals",
  "memorabilia",
  "property rental",
  "other",
];

function capitalize(text) {
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
}

export function categoryName(category) {
  return capitalize(category || "other");
}

// "Other" listings may carry the seller's own word for the category.
export function itemCategoryLabel(item) {
  if (item.category === "other" && item.category_other) {
    return capitalize(item.category_other);
  }
  return categoryName(item.category);
}

// "$1,200" for whole dollars, "$12.50" otherwise; null means "Make an offer".
export function formatPrice(price) {
  if (price === null || price === undefined || price === "") return null;
  const n = Number(price);
  if (!Number.isFinite(n)) return null;
  const cents = Math.round(n * 100) % 100 !== 0;
  return `$${n.toLocaleString("en-US", {
    minimumFractionDigits: cents ? 2 : 0,
    maximumFractionDigits: 2,
  })}`;
}

export function sellerName(item) {
  return item.seller_name || "A family member";
}
